import { ResetReducerState } from './types';

export const getDefaultState = (): ResetReducerState => ({
  is_processing: false,
  errors: [],
  message: ''
});